import { IOrderComposition } from "../../../../../modules/cart/domain/models/IOrderComposition"
import { PrincingTypeEnum } from "../../../../../modules/catalog/domain/models/PrincingTypeEnum";


export const CalcTotalsOfCompositionItemByCompositionId = (prevOrderConposition: IOrderComposition[], productCompositionItemId: string): { quantity: number, price: number } => {

    const calcTotalsOfCompositionItemByCompositionId = (prevOrderComposition: IOrderComposition[], productCompositionItemId: string) => {

        const compositionItem = prevOrderComposition.flatMap(_composition => _composition.compositionItems).find(_item => _item.id === productCompositionItemId)

        const composition = prevOrderComposition.find(x => x.compositionItems.find(y => y.id === productCompositionItemId));

        let price = compositionItem?.totalPrice;
       
        if (composition?.pricingType === PrincingTypeEnum.MAX) {
            let maxPriceComposition = composition.compositionItems[0];
            composition.compositionItems.forEach(item => {
                if (item.price > maxPriceComposition.price) {
                    maxPriceComposition = item;
                }
            })

            if (maxPriceComposition.id !== productCompositionItemId) {
                price = 0;
            }
        }
        if (compositionItem) {
            return { quantity: compositionItem.quantity, price: price ?? compositionItem.price }
        }
        return { quantity: 0, price: 0 }
    }

    return calcTotalsOfCompositionItemByCompositionId(prevOrderConposition, productCompositionItemId);
}
//export const CalcTotalsOfCompositionItemByCompositionId = (prevOrderConposition: IOrderComposition[], productCompositionItemId: string): { quantity: number, price: number } => {

//    const calcTotalsOfCompositionItemByCompositionId = (prevOrderComposition: IOrderComposition[], productCompositionItemId: string) => {

//        const composition = prevOrderComposition.flatMap(_composition => _composition.compositionItems).find(_item => _item.id === productCompositionItemId)
//        if (composition) {
//            return { quantity: composition.quantity, price: composition.totalPrice }
//        }
//        return { quantity: 0, price: 0 }
//    }

//    return calcTotalsOfCompositionItemByCompositionId(prevOrderConposition, productCompositionItemId);
//}